<div class="container-fluid">
    <div class="row section" id="footer">
        <div class="col-sm-12">
            <div class="container">
                <div class="row text-center">
                    <div class="col-sm-3">
                        <a href="https://www.facebook.com/NCPSpeaks/" target="_blank" class="social-link"><i class="fab fa-facebook-square"></i> NCPSpeaks</a>
                    </div>
                    <div class="col-sm-3">
                        <a href="https://twitter.com/ncpspeaks" target="_blank" class="social-link"><i class="fab fa-twitter"></i> NCPSpeaks</a>
                    </div>
                    <div class="col-sm-3">
                        <a href="https://www.instagram.com/ncp_youth_speaks/" target="_blank" class="social-link"><i class="fab fa-instagram"></i> NCPSpeaks</a>
                    </div>
                    <div class="col-sm-3">
                        <a href="https://www.youtube.com/user/ncpspeaks" target="_blank" class="social-link"><i class="fab fa-youtube"></i> NCPSpeaks</a>
                    </div>
                </div>
                <hr />
                <div class="row" id="bottom">
                    <div class="col-sm-12 text-center">
                        Copyright © 2021, <a href="http://ncpyouths.com" target="_blank">http://ncpyouths.com</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>